import { useApiClient } from '@chilipiper/api-client/src/context'
import { queryKeyFactory } from '@chilipiper/api-queries/src/personal-details'
import { useQuery } from '@tanstack/react-query'

export const usePersonalDetails = (tenantId: string, userId = '') => {
  const { workspaceV3 } = useApiClient()
  return useQuery({
    queryKey: queryKeyFactory.findPersonalDetails(tenantId, userId),
    queryFn: () => workspaceV3.guestFindPersonalDetailsV3(tenantId, userId),
    enabled: userId !== '',
  })
}

export const useProfilePictureUrl = (tenantId: string, userId = '') => {
  const { workspaceV3 } = useApiClient()
  return useQuery({
    queryKey: queryKeyFactory.getPicture(tenantId, userId),
    queryFn: () => workspaceV3.guestGetPictureOfUserV3(tenantId, userId),
    enabled: userId !== '',
  })
}
